import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './ToolPage.css'
import './Tournament.css'
import TournamentBoard from './TournamentBoard'
import { fetchTournamentState, tournamentStreamUrl } from './utils/tournamentApiClient'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const FORMAT_LABELS = {
  league: 'Pontos corridos',
  knockout: 'Mata-mata',
  groups: 'Grupos + mata-mata',
}

const TournamentView = () => {
  useDocumentMeta({
    title: 'Campeonato ao Vivo | jarder.dev',
    description: 'Acompanhe a classificação ou o chaveamento do campeonato em tempo real.',
  })

  const { id } = useParams()
  const [state, setState] = useState(null)
  const [status, setStatus] = useState('loading')

  useEffect(() => {
    let cancelled = false

    fetchTournamentState(id)
      .then((data) => {
        if (cancelled) return
        setState(data)
        setStatus('ready')
      })
      .catch(() => {
        if (!cancelled) setStatus('notfound')
      })

    const eventSource = new EventSource(tournamentStreamUrl(id))
    eventSource.onmessage = (event) => {
      setState(JSON.parse(event.data))
    }

    return () => {
      cancelled = true
      eventSource.close()
    }
  }, [id])

  if (status === 'loading') {
    return (
      <div className="tool-page">
        <p>Carregando...</p>
      </div>
    )
  }

  if (status === 'notfound') {
    return (
      <div className="tool-page">
        <Link to="/ferramentas" className="tool-back-link">
          ← Todas as ferramentas
        </Link>
        <h1>Torneio não encontrado</h1>
        <p className="tool-disclaimer">Esse torneio não existe ou expirou.</p>
      </div>
    )
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Campeonato ao Vivo</h1>
      <p className="tool-disclaimer">
        Acompanhando ao vivo. Formato: <strong>{FORMAT_LABELS[state.format]}</strong>.
      </p>

      <TournamentBoard state={state} editable={false} />
    </div>
  )
}

export default TournamentView
